<template>
    <div>
        <v-row justify="center" class="my-5">
            <v-col cols="12" sm="6">
                <p class="text-center font-weight-bold">
                    {{ sender.destination_user_name }} ( {{ sender.destination_email_address }} ) 様より
                </p>
                <p class="text-center font-weight-bold">
                    契約の確認依頼が届きました。
                </p>
                <p class="text-center">
                    <a href="/support" target="_blank" rel="noopener noreferrer">DX-Signの使い方</a>
                </p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="10">
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row justify="center" class="mt-10">
            <v-col cols="12" sm="5">
                <p class="text-center" v-if="!isLogin">
                    <a href="/documents/terms" target="_blank" rel="noopener noreferrer">利用規約</a>に同意の上、契約の内容を確認してください。
                </p>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-btn
              class="white--text"
              color="red"
              v-on:click="submit"
            >
              <span v-if="!isLogin">利用規約に同意して</span>契約を確認する
            </v-btn>
        </v-row>
    </div>
</template>

<script>
  export default {
    props: {
        sender: {
            type: Object,
        },
        $recipient: {
            type: Object,
        },
        isLogin: Boolean,
    }, 
    methods: {
        submit: function () {
            axios.post('auth')
            .then(function (response) {
                if (response.data.success) {
                    window.location = "sign-input";
                } else {
                    console.log(response);
                }
            })
            .catch(function (response) {
                console.log(response);
            });
        }
    },
};
</script>